export default __webpack_public_path__ + "static/media/calculation.e532383b.png";